import { render, staticRenderFns } from "./FontSizeFilter.vue?vue&type=template&id=a6fc5e12&"
import script from "./FontSizeFilter.vue?vue&type=script&lang=js&"
export * from "./FontSizeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports